import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import { DialogContent, DialogTitle } from 'components/common/DialogApi'
import DialogContentText from '@mui/material/DialogContentText'
import PropTypes from 'prop-types'
import Transition from './Transition'
import { DialogActions, useMediaQuery } from '@mui/material'

const ReuseConfirmationDialog = ({
    handleConfirm,
    handleCancel,
    dialogData,
    open,
}) => {
    const handleClose = function () {
        handleCancel()
    }
    const onConfirm = function () {
        handleConfirm()
    }
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="delete-dialog"
            aria-describedby="delete-dialog-slide-description"
            id="deactivate-dialog"
        >
            <DialogTitle id="delete-dialog" onClose={handleClose}>
                {dialogData.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-dialog-slide-description">
                    {dialogData.desc}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    fullWidth={!matches}
                    onClick={onConfirm}
                    variant="contained"
                    color="primary"
                >
                    Yes
                </Button>
                <Button
                    fullWidth={!matches}
                    onClick={handleClose}
                    color="secondary"
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    )
}
ReuseConfirmationDialog.propTypes = {
    dialogData: PropTypes.shape({
        title: PropTypes.string.isRequired,
        desc: PropTypes.string.isRequired,
    }).isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
}

export default ReuseConfirmationDialog
